// extracted by mini-css-extract-plugin
module.exports = {"Title":"styles_Title__tn8jO"};